import '../scss/app.scss'

import $ from 'jquery'

const userAgents = ['iPad', 'iPhone', 'Android', 'IEMobile', 'BlackBerry']

export const isMobile = () => {
	let userAgent
	const isMobile = {
		any: false
	}

	$.each(userAgents, function (index) {
		userAgent = userAgents[index]

		isMobile[userAgent] = navigator.userAgent.toLowerCase().indexOf(userAgent.toLowerCase()) > -1

		if (isMobile[userAgent]) isMobile.any = true
	})

	return isMobile
}

export const mobile = isMobile()

const $win = $(window)
const $navLi = $('.navbar .navbar-nav .nav-item')

function winScroll() {
	const st = $win.scrollTop()
	if (st > 10) {
		$('nav.navbar-marketing').addClass('navbar-scrolled')
	} else {
		$('nav.navbar-marketing').removeClass('navbar-scrolled')
	}
}

export const enableNavbarScroll = () => {
	winScroll();
	$win.scroll(winScroll)
}

export const setActiveNav = () => {
	const {href} = window.location
	const inc = name => href.includes(name)
	$navLi.find('a').removeClass('active')
	if (inc('product')) {
		$navLi.find('.product').addClass('active')
	} else if (inc('about')) {
		$navLi.find('.about').addClass('active')
	} else {
		$navLi.find('.index').addClass('active')
	}
}

export const setCopyright = () => {
	const year = new Date().getFullYear()
	$('#copyright').html(`2020-${year}`)
}



// WEBPACK FOOTER //
// ./src/en/lib/app/js/app.js